import styled from 'styled-components'
import chevronLeft from '../../assets/icons/chevron-left.svg'
import chevronRight from '../../assets/icons/chevron-right.svg'
import { GREEN, WHITE } from '../../utils/colors'

export const Container = styled.div`
  margin-top: 58px;

  ul {
    text-align: center;

    li {
      &:hover {
        opacity: 0.8;
      }

      a {
        display: inline-block;
        width: 100%;
        height: 100%;
        font-size: 14px;
        line-height: 38px;
      }

      cursor: pointer;
      display: inline-block;
      background: ${WHITE};
      border: 1px solid #E7E7E7;
      box-sizing: border-box;
      border-radius: 50px;
      width: 40px;
      height: 40px;
      color: ${GREEN};
      margin: 5px;

      &.disabled {
        opacity: 0.5;
        &:hover {
          opacity: 0.5;
        }
      }

      &.selected {
        background-color: ${GREEN};
        color: ${WHITE};
        border-color: ${GREEN};
      }

      &.previous, &.next {
        color: transparent;
        background-image: url(${chevronLeft});
        background-position: center center;
        background-repeat: no-repeat;
      }

      &.next {
        background-image: url(${chevronRight});
      }
    }
  }
`
